import { useQuery, gql } from '@apollo/client';
import { GetNeighborhoodsForFloorQuery } from './__generated__/useNeighborhoods.generated';

export type NeighborhoodData =
  GetNeighborhoodsForFloorQuery['getNeighborhoodsForFloor'];

const query = gql`
  query GetNeighborhoodsForFloor($floorId: ID!) {
    getNeighborhoodsForFloor(floorId: $floorId) {
      neighborhoods {
        id
        name
        resources {
          resourceId
        }
        colorDefinition {
          base
          label {
            text
            background
          }
        }
      }
      showNeighborhoodColors
    }
  }
`;

export function useNeighborhoods(
  floorId?: string
): NeighborhoodData | undefined {
  const { data } = useQuery<GetNeighborhoodsForFloorQuery>(query, {
    variables: {
      floorId: Number(floorId),
    },
    skip: !floorId,
  });

  return data?.getNeighborhoodsForFloor;
}
